import React from "react";
import { withRouter } from "react-router-dom";

interface IScrollToTopProps {
  location: any;
  history: any;
  match: any;
}

class ScrollToTop extends React.Component<IScrollToTopProps> {
  componentDidUpdate(prevProps: any) {
    if (
      this.props.location.pathname !== prevProps.location.pathname
    ) {
      console.log('scroll top ', window)
      window.scrollTo(0, 0);
    }
  }

  render() {
    return null;
  }
}

export default withRouter(ScrollToTop);
